import React from 'react';
import { connect } from 'react-redux';

import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import FilingFrequencyFilter from '../../../utils/filingFrequencyFilters';
import {FilingTypeEnum} from '../../../utils/enums';
import { SSelect } from "@avalara/skylab-sdk/react";

const log = new Logger('FILING_FREQUENCY_SELECTOR', LOG_LEVELS.DEBUG);

export class FilingFrequencySelector extends React.Component {

    selectionHandler(event) {
        // Guard: Skylab SSelect fires s-select event on click outside with empty value
        // This prevents resetting the selection when user clicks outside dropdown
        const selectedValue = event?.detail?.item?.value;
        if (!selectedValue) {
            return;
        }
        
        const selectedFrequency = this.props.frequencies[selectedValue] || this.props.frequencies[Number(selectedValue)];
        if (!selectedFrequency) {
            return;
        }
        
        log.debug('selectionHandler: selection: ', selectedFrequency);
        if(this.props.fieldName)
          this.props.selectionHandler(selectedFrequency, this.props.fieldName);
        else
           this.props.selectionHandler(selectedFrequency);
    }

    getFilingFrequencyOptions() {
      const frequenciesArray = (this.props.frequencies)? Object.values(this.props.frequencies) : [];
      let optionsList = [];
      if(this.props.showDefaultValue) {
        optionsList.push({
          label: LANGUAGES_CONTROLLER.format(this.props.languages, this.props.placeholderTextLanguageString),
          value: "",
        });
      }
      frequenciesArray.forEach((frequency, key) => {
        const selectable = (!this.props.validPeriodIds ||
        (Array.isArray(this.props.validPeriodIds) && this.props.validPeriodIds.length <= 0) ||
        this.props.validPeriodIds.indexOf(frequency.id) >= 0);
        optionsList.push({
          label: LANGUAGES_CONTROLLER.format(this.props.languages, frequency.languageString),
          value: frequency.id+'',
          disabled: !selectable,
          selected: String(this.props.value) === String(frequency.id)
        });
      })
      return optionsList;
    }

    render() {
      log.debug('render(): ', this.props);

      return (
          <fieldset className={this.props.inline === true ? ("inline") : ("block")} disabled ={this.props.isDisabled}>
            <label className="mr5">{this.props.labelText}:</label>
            <div data-test="component-filing-frequency-select" className="component-filing-frequency-select">
              <SSelect defaultValue={this.props.value}
                inputId="single-filing-frequency-select"
                name="frequency"
                onS-select={this.selectionHandler.bind(this)}
                optionsList={this.getFilingFrequencyOptions() || []}
                multiple={false}
                showSelectionCount={false}
              />
            </div>
          </fieldset>
        )
    }
}

function mapStateToProps(state, fromTag) {
  log.debug('mapStateToProps: ', state, fromTag);
  let reportTypeFrequencies = fromTag.frequencies;
  if (!reportTypeFrequencies)  //test number of properties when object is defined
  {
    reportTypeFrequencies = (state.content && state.content.contentData && state.content.contentData.filingFrequencies);
    if(!reportTypeFrequencies) return {};
    switch (fromTag.filingTypeId) {
      case FilingTypeEnum.VATRETURN:
      case FilingTypeEnum.VATBOOKS:
        break;
      case FilingTypeEnum.ECLISTING:
        reportTypeFrequencies = FilingFrequencyFilter.EcListingFilter(reportTypeFrequencies);
        break;
      case FilingTypeEnum.INTRASTAT:
        reportTypeFrequencies = FilingFrequencyFilter.IntrastatListingFilter(reportTypeFrequencies);
        break;
      case FilingTypeEnum.LOCALLISTING:
      case FilingTypeEnum.REVERSECHARGELISTING:
        reportTypeFrequencies = FilingFrequencyFilter.LocalListingFilter(reportTypeFrequencies);
        break;
      case FilingTypeEnum.EXTRASTAT:
        reportTypeFrequencies = FilingFrequencyFilter.extrastatFilter(reportTypeFrequencies);
        break;
      case FilingTypeEnum.OSSIMPORT:
            reportTypeFrequencies = FilingFrequencyFilter.OSSImportFilter(reportTypeFrequencies);
            break;
      case FilingTypeEnum.OSSUNION:
      case FilingTypeEnum.OSSNONUNION:
            reportTypeFrequencies = FilingFrequencyFilter.OSSFilter(reportTypeFrequencies);
            break;
        default:
        break;
    }

  }
  return {
    languages: state.languages,
    frequencies: reportTypeFrequencies,
    isDisabled: (state.navigationMenuVisibility && state.navigationMenuVisibility.hideNavigationMenu)||false
  };
}


FilingFrequencySelector.defaultProps = {
  placeholderTextLanguageString: 'select_filingFrequency'
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(FilingFrequencySelector);
